// import React, { useEffect, useState } from "react";
// import { TreeSelect } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { createOrgToOrgMapping, getDropdownHierarchyByCode } from "../OrganizationService";

// const transformMenusToTreeData = (menus) => {
//   if (!menus || !menus.hierarchy_node) {
//     return [];
//   }

//   const { hierarchy_node, child_node } = menus;

//   const node = {
//     id: hierarchy_node.id,
//     value: hierarchy_node.organization_id,
//     title: hierarchy_node.name,
//     children: [],
//   };

//   if (child_node && Array.isArray(child_node)) {
//     node.children = child_node
//       .map((child) => transformMenusToTreeData(child))
//       .flat();
//   }

//   return [node];
// };

// const TreeStructureDropdown = ({ hierarchy_code, getValue }) => {
//   const [value, setValue] = useState();
//   const [isInitialSelection, setIsInitialSelection] = useState(true);
//   const dispatch = useDispatch();
//   const orgMappingData = useSelector(
//     (state) => state.organization.selectedOrganization.orgMappingData
//   );
//   const menus = useSelector(
//     (state) => state.organization.selectedOrganization.menus
//   );
//   const data = useSelector(
//     (state) => state.organization.selectedOrganization.detailsData
//   );
//   const orgCode = useSelector(
//     (state) => state.organization.selectedOrganization.orgCode
//   );
//   const hierCode = useSelector(
//     (state) => state.organization.selectedOrganization.hierCode
//   );

//   useEffect(() => {
//     if (getValue) {
//       setValue(getValue());
//     }
//   }, [getValue]);

//   const onChange = (newValue) => {
//     setValue(newValue);
//     if (isInitialSelection) {
//       createOrgToOrgMapping(newValue, data.organizationId, hierCode);
//       setIsInitialSelection(false); // Reset after the first selection
//     } else {
//       // Call the update API here
//       // updateOrgToOrgMapping(newValue, data.organizationId, hierCode); // Define this function as per your requirement
//     }
//   };

//   const handleDropdownClick = () => {
//     getDropdownHierarchyByCode(hierarchy_code);
//   };

//   const treeData = transformMenusToTreeData(menus);

//   return (
//     <TreeSelect
//       showSearch
//       style={{ width: "100%" }}
//       value={value}
//       dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
//       placeholder="Please select"
//       allowClear
//       treeDefaultExpandAll
//       onChange={onChange}
//       onClick={handleDropdownClick}
//       treeData={treeData}
//     />
//   );
// };

// export default TreeStructureDropdown;

import React, { useEffect, useState } from "react";
import { TreeSelect, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrgToOrgMapping,
  getDropdownHierarchyByCode,
  updateHierarchy,
} from "../OrganizationService";
import "../Organization.scss";

const transformMenusToTreeData = (menus) => {
  if (!menus || !menus.hierarchy_node) {
    return [];
  }

  const { hierarchy_node, child_node } = menus;

  const node = {
    id: hierarchy_node.id,
    value: hierarchy_node.organization_id,
    title: hierarchy_node.name,
    children: [],
  };

  if (child_node && Array.isArray(child_node)) {
    node.children = child_node
      .map((child) => transformMenusToTreeData(child))
      .flat();
  }

  return [node];
};

const TreeStructureDropdown = ({ hierarchy_code, getValue, code}) => {
  const [value, setValue] = useState();
  const [id, setId] = useState();
  const dispatch = useDispatch();
  const [buttonLabel, setButtonLabel] = useState("Save");
  const [selectedNodeId, setSelectedNodeId] = useState();
  const orgMappingData = useSelector(
    (state) => state.organization.selectedOrganization.orgMappingData
  );
  const menus = useSelector(
    (state) => state.organization.selectedOrganization.menus
  );
  const data = useSelector(
    (state) => state.organization.selectedOrganization.detailsData
  );
  const orgCode = useSelector(
    (state) => state.organization.selectedOrganization.orgCode
  );
  const hierCode = useSelector(
    (state) => state.organization.selectedOrganization.hierCode
  );
  const parentId = useSelector(
    (state) => state.organization.selectedOrganization.parentId
  );
  const [isInitialValueSet, setIsInitialValueSet] = useState(false);
  useEffect(() => {
    const initialValue = getValue ? getValue() : undefined;
    setValue(initialValue);
    setIsInitialValueSet(!!initialValue);
    setButtonLabel(initialValue ? "Update" : "Save");
  }, [getValue]);

  const onChange = (newValue, label, extra) => {
    setValue(newValue);
    if (extra && extra.triggerNode && extra.triggerNode.props) {
      const selectedNode = extra.triggerNode.props;
      setSelectedNodeId(selectedNode.id);
    } else {
      setSelectedNodeId(null);
    }

    if (isInitialValueSet) {
      setButtonLabel("Update");
    } else {
      setButtonLabel("Save");
    }
  };
  const handleDropdownClick = () => {
    getDropdownHierarchyByCode(hierarchy_code);
  };

  const handleSave = () => {
    createOrgToOrgMapping(value, data.organizationId, hierCode);
  };

  // const handleUpdate = () => {
  //   const hierarchyId = orgMappingData?.find(
  //     (item) => item.code === hierarchy_code
  //   )?.hierarchy_id;
  //   updateHierarchy(parentId, hierarchyId);
  // };

  const handleUpdate = () => {
    const selectedMapping = orgMappingData.find(
      (item) => item.code === code
    );
  
      const hierarchyId = selectedMapping.hierarchy_id;
      updateHierarchy(selectedNodeId, hierarchyId);
  };

  const treeData = transformMenusToTreeData(menus);

 
  
  const handleButtonClick = () => {
    if (buttonLabel === "Save") {
      handleSave();
    } else {
      handleUpdate();
    }
  };

  return (
    <div className="tree-structure">
      <TreeSelect
        showSearch
        style={{ width: "100%" }}
        value={value}
        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
        placeholder="Please select"
        allowClear
        treeDefaultExpandAll
        onChange={onChange}
        onClick={handleDropdownClick}
        treeData={treeData}
      />
      <Button type="primary" onClick={handleButtonClick}>
        {buttonLabel}
      </Button>
    </div>
  );
};

export default TreeStructureDropdown;
